import { type DeviceCause, DeviceCauseKey, DeviceStatusType } from '@cobliteam/api-lib/src/__generated__/graphql';
import { useTranslation } from '@cobliteam/i18n';
import { Tag, Tooltip } from '@cobliteam/ui/components';
import type { TagProps } from '@cobliteam/ui/components/Tag';
import Icon from '@cobliteam/ui/icons';

const tagColor: Record<DeviceStatusType, TagProps['color']> = {
  [DeviceStatusType.Critical]: 'danger-dark',
  [DeviceStatusType.Check]: 'warning',
  [DeviceStatusType.Healthy]: 'default',
};

interface DeviceCausesProps {
  causes: DeviceCause[];
  extendedLabel?: boolean;
  showFirstOnly?: boolean;
  showHealthyCauses?: boolean;
}

const DeviceCauses = ({ causes, extendedLabel = false, showFirstOnly = false, showHealthyCauses = false }: DeviceCausesProps) => {
  const { t } = useTranslation('devices');

  const getLabel = (cause: DeviceCauseKey) => {
    if (extendedLabel) {
      return t(`device_status_description.${cause.toLowerCase()}`);
    }

    return t(`device_status.${cause.toLowerCase()}`);
  };

  const causesToShow = showFirstOnly ? causes.slice(0, 1) : causes;
  const causesList = showHealthyCauses ? causesToShow : causesToShow.filter((cause) => cause.status !== DeviceStatusType.Healthy);

  return (
    <div className='flex flex-wrap items-center gap-2'>
      {causesList.map(({ cause, status }) => (
        <Tooltip key={cause} content={t(`status_modal.${cause.toLowerCase()}_description`)} position='bottom' asChild>
          <div>
            <Tag label={getLabel(cause)} color={tagColor[status]} variant='surface' icon={cause === DeviceCauseKey.NoSignal ? <Icon name='wifi-off' /> : undefined} />
          </div>
        </Tooltip>
      ))}
    </div>
  );
};

export default DeviceCauses;
